/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState } from 'react';
import { AnyProps } from '../types';
import { flattenProps } from '../../services/compMapping';
import { maskAssetUrl } from '../props/asset';

const GenericLinkComponents = {
  RocheGenericLink: {
    props: {
      'tracking-type': 'generic',
    },
  },
  RocheDownloadLink: {
    props: {
      target: '_self',
      icon: 'download',
      'tracking-type': 'download',
    },
    mappings: {
      url: 'src', // type: asset,
    },
  },
  /** Deprecated */
  RocheExternalLink: {
    props: {
      target: '_blank',
      icon: 'new-window',
      'tracking-type': 'external',
    },
  },
  /** Deprecated */
  RocheInternalLink: {
    props: {
      target: '_self',
      'tracking-type': 'internal',
    },
  },
};

const getRocheGenericLink = (comp): React.ElementType => {
  // giving the function a name is just to have named mappings for debugging purposes
  const RocheGenericLink = ({ blok, slot }: AnyProps): JSX.Element => {
    const [linkFields, setLinkFields] = useState(blok);
    const URL = blok.url?.story?.url ? `/${blok.url?.story?.url}` : blok.url?.url;

    useEffect(() => {
      if (blok.url.linktype === 'story') {
        setLinkFields({
          ...linkFields,
          url: URL,
        });
      }

      if (blok.url.linktype === 'asset') {
        const maskedAssetUrl = maskAssetUrl(linkFields.url.url);

        setLinkFields({
          ...linkFields,
          url: maskedAssetUrl,
        });
      }

      if (comp.props['tracking-type'] === 'generic') {
        if (!blok.icon) {
          if (blok.url.linktype === 'story') {
            setLinkFields({
              ...linkFields,
              target: '_self',
              icon: 'chevron-right',
            });
          }
          if (blok.url.linktype === 'url') {
            setLinkFields({
              ...linkFields,
              target: '_blank',
              icon: 'new-window',
            });
          }
        }
        if (blok.hide_icon) {
          setLinkFields({
            ...linkFields,
            icon: '',
          });
        }
        // TODO: check if a better ways exists
        /*
        Roche.de stories link are always appended to the existing slug and they shouldn't be
        */
        if (blok.url.fieldtype === 'multilink' && !blok.url.linktype) {
          setLinkFields({
            ...linkFields,
            url: `/${linkFields.url.url}`,
            target: '_self',
            icon: 'chevron-right',
          });
        }
      }
    }, []);

    return React.createElement(
      'roche-generic-link',
      { ...flattenProps(comp, linkFields), ...comp.props, slot },
    );
  };
  return RocheGenericLink;
};

export const rocheGenericLinkComponents = Object.keys(GenericLinkComponents)
  .reduce((accumulator, componentName) => ({
    ...accumulator,
    [componentName]: getRocheGenericLink(GenericLinkComponents[componentName]),
  }), {});
